<template>
  <div id="notificationsComponent">
    <v-card class="pa-5">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-form lazy-validation ref="searchValidation">
          <v-text-field
            style="max-width: 250px"
            dense
            outlined
            hide-details
            clearable
            :placeholder="$t('general.search')"
            v-model="search"
            append-icon="search"
            class="mr-2"
            :rules="rules.textNoSpecialChars"
            @keyup.enter="searching"
            @click:append="searching"
          ></v-text-field>
        </v-form>
        <!-- ELIMINADO POR ORDENES DEL SPRINT -->
        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              text
              small
              color="primary"
              fab
              dark
              class="mx-2"
              v-show="selected.length > 0"
              @click="markMassiveView"
            >
              <v-icon>far fa-check-circle</v-icon>
            </v-btn>
          </template>
          <span>{{$t('notification.markSelect')}}</span>
        </v-tooltip> -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              text
              outlined
              small
              color="error"
              fab
              dark
              class="mx-2"
              v-show="selected.length > 0"
              @click="massiveDelete"
            >
              <v-icon>
                far fa-trash-alt
              </v-icon>
            </v-btn>
          </template>
          <span>{{$t('notification.deleteSelect')}}</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <v-overlay absolute opacity="0" :value="loadTable"/>
        <v-data-table
          :headers="headers"
          :items="notifications"
          :options.sync="options"
          :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
          :server-items-length="options.total"
          :loading="loadTable"
          @update:page="get"
          @update:items-per-page="get"
          @update:sort-by="get"
          @update:sort-desc="get"
          v-model="selected"
          show-select
        >
          <template v-slot:item="props" >
            <tr>
              <td><v-checkbox v-model="selected" :value="props.item"/></td>
              <td>{{props.item.created_at}}</td>
              <td>{{props.item.tittle}}</td>
              <td>{{props.item.message}}</td>
              <td>
                <v-chip :color="props.item.importance_level === 'HIGH' ? 'error' : 'primary' ">
                  {{$t('notification.' + props.item.importance_level)}}
                </v-chip>
              </td>
              <td>{{ props.item.is_read === 0 ? $t('notification.no') : $t('notification.yes')}}</td>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="props.item.is_read === 0" @click="markAsView(props.item)" small v-on="on" class="mr-2">far fa-eye</v-icon>
                  </template>
                  <span>{{$t('inspections.view')}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon @click="deleteItem(props.item)" v-on="on" small class="mr-2">far fa-trash-alt</v-icon>
                  </template>
                  <span>{{$t('general.delete')}}</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="error--text grey lighten-5">
          {{title}}
        </v-card-title>
        <v-card-text class="pt-5">
          <span>{{message}}</span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close" color="error" outlined>
           {{$t('general.cancel')}}
          </v-btn>
          <v-btn @click="deleteNotif" :loading="loading" :disabled="loading" color="error">
           {{$t('general.delete')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogView" width="500">
      <v-card>
        <v-card-title class="primary--text">
          {{title}}
        </v-card-title>
        <v-card-text class="pt-5">
          <span>{{message}}</span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close" color="primary" outlined>
           {{$t('general.cancel')}}
          </v-btn>
          <v-btn @click="markMassive" :loading="loading" :disabled="loading" color="primary">
           {{$t('general.accept')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'notificationsComponent',
  data () {
    return {
      dialog: false,
      dialogView: false,
      loadTable: false,
      loading: false,
      message: '',
      title: '',
      selected: [],
      item: {},
      options: {
        itemsPerPage: 15,
        page: 1,
        total: 0
      },
      notifications: [],
      search: ''
    }
  },
  watch: {
  },
   computed: {
    headers() {
      return [
        {
          text: this.$t('general.date'),
          align: 'left',
          value: 'created_at',
          sortable: true
        },
        {
          text: this.$t('notification.title'),
          align: 'left',
          value: 'tittle',
          sortable: true
        },
        {
          text: this.$t('notification.message'),
          align: 'left',
          value: 'message',
          sortable: true
        },
        {
          text: this.$t('notification.importance'),
          align: 'left',
          value: 'importance_level',
          sortable: true
        },
        {
          text: this.$t('notification.view'),
          align: 'left',
          value: 'is_read',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'left',
          sortable: false
        }
      ]
    },
    rules () {
      return this.$validationRules()
    }
   },
   created () {
     this.get()
   },
   methods: {
    deleteItem (item) {
      this.$store.dispatch('notifications/delete', { event: { id: item.id, context: this } })
    },
    markAsView (item) {
      this.$store.dispatch('notifications/markAsView', { event: { id: item.id, context: this } })
    },
    markMassive () {
      this.loading = true

      let items = []

      this.selected.forEach(item => { items.push(item.id) })
      
      this.$store.dispatch('notifications/markMultiple', { event: { items, context: this } })
    },
    close () {
      this.selected = []
      this.loading = false
      this.dialogView = false
      this.dialog = false
    },
    markMassiveView () {
      this.title = this.$t('notification.markSelect')
      this.message = this.$t('notification.markMassive')
      this.dialogView = true
    },
    massiveDelete () {
      this.title = this.$t('notification.delete')
      this.message = this.$t('notification.delMassive')
      this.dialog = true
    },
    deleteNotif () {
      this.loading = true
      
      let items = []
      
      this.selected.forEach(item => { items.push(item.id) })
      
      this.$store.dispatch('notifications/deleteMultiple', { event: { items, context: this } })
    },
    searching () {
      if(this.search && !this.$refs.searchValidation.validate()) return this.showNotification(this.$t('validation.noSpecialChars'), 'warn', -1)
    
      this.$refs.searchValidation.resetValidation()

      this.options.page = 1
      this.options.perPage = 5
      this.get()
    },
    get () {   
      this.loadTable = true

      this.$store.dispatch('notifications/get', {
        event: {
          perPage: this.options.itemsPerPage,
          page: this.options.page,
          sortKey: this.options.sortBy ? this.options.sortBy[0] : 'id',
          ord: this.options.sortDesc && this.options.sortDesc[0] ? 'asc' : 'desc',
          find: this.search === '' ? undefined : this.search,
          context: this
        }
      })
    },
    redirectInspection (inspectionId) {
      this.$router.push('inspections/view/' + inspectionId)
    }
  }
}
</script>